import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 3.40755L8.90852 2.5 6.94303 5.04801 3.90968 6.13019 3.8148 9.34424 2 12l1.8148 2.6558.09488 3.214 3.03242 1.0831L8.90852 21.5l3.09098-.9075 3.092.9075 1.9655-2.5471 3.0333-1.0831.0949-3.214L22 12l-1.8148-2.65576-.0949-3.21405-3.0324-1.08218L15.0915 2.5l-3.092.90755zm3.0631 5.61435l1.3153 1.3126-5.3086 5.3013-3.44817-3.4435 1.31622-1.3135 2.13195 2.1309 3.9933-3.9878z",
    fill: "currentColor"
  }));
});